import cookies from 'js-cookie';

export const state = () => ({
  tests: {},
});

export const getters = {
  getTest(state) {
    return state.tests;
  },
  loginSignupTest(state) {
    if (state.tests) {
      return state.tests['login-signup'];
    }

    return false;
  },
};

export const mutations = {
  setUserTests(state, tests) {
    state.tests = tests;
  },
};

export const actions = {
  setUserTests({ commit }, tests) {
    commit('setUserTests', tests);

    if (process.client) {
      cookies.set('abTests', tests, { expires: 1000, domain: `.${this.$config.primaryCookiesDomain}` });
    }
  },
};
